import { useTranslation } from "gatsby-plugin-react-i18next";
import TA from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import it from "javascript-time-ago/locale/it";
import React from "react";

TA.addLocale(it);
TA.addLocale(en);

const TimeAgo = ({ date, className }: { date: string; className?: string }) => {
  const { i18n } = useTranslation();
  const [ta] = React.useState(new TA(i18n.language));

  return (
    <time dateTime={date} className={className}>
      {ta.format(new Date(date))}
    </time>
  );
};

export default TimeAgo;
